import React from "react";
import classes from './ListCard.module.css';

const ListCard = (props) => {
    return (
        <div className={`${classes.card} ${props.secondaryClassName}`} onClick={props.onClick}>
         {props.children}
        </div>

    );
}

export default ListCard;